import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    CanActivateChildFn,
    CanActivateFn,
    Router
} from '@angular/router';
import { controlAccessPopUp } from '@app/modules/ui-notification/ControlAccessDialog/controlaccess.component';
import { UserService } from 'app/core/user/user.service';
import { map } from 'rxjs/operators';


export enum Licence {
    Freemium = 0,
    DataAnalysis = 1,
    DataQuality = 2,
    CorporatingsViewer = 3,
    CorporatingsAdmin = 4
}

export function LicenseGuardGenerator(routes: string[], minLicence: Licence): CanActivateFn | CanActivateChildFn {
    return (route, state) => { 
        const router: Router = inject(Router);
        const _userService: UserService = inject(UserService);
        const _matDialog: MatDialog = inject(MatDialog);
        const redirectToCompany = routes.find(r => location.pathname.includes(r))!= null
        return _userService.user$.pipe(map(u => {
                if (u.accessLevel < minLicence) {
                    var neededAccountLicence: string = "Premium"
                    switch (minLicence) {
                        case 2: neededAccountLicence = "Premium +"; break
                        case 3: neededAccountLicence = "Corporatings viewer"; break
                        case 4: neededAccountLicence = "Corporatings Admin"; break
                        default: break
                    }
                    if (redirectToCompany) {
                        router.navigate(['/']).then(
                            (navigated: boolean) => {
                                controlAccessPopUp(
                                    _matDialog,
                                    `Subscribe to a <span class="text-red-500">${neededAccountLicence}</span> account to unlock this feature`,
                                    "Subscribe to " + neededAccountLicence
                                );
                            }
                        )
                    }
                    else {
                        controlAccessPopUp(
                            _matDialog,
                            `Subscribe to a <span class="text-red-500">${neededAccountLicence}</span> account to unlock this feature`,
                            "Subscribe to " + neededAccountLicence
                        );
                    }
                }
                return u.accessLevel >= minLicence;
            }))

    }
}



